import { useEffect } from 'react';

import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';

const LONG_PRESS_MENU_TARGETS = 'a[href], img, video';

const isMouseRightClick = (event: MouseEvent) =>
  event instanceof PointerEvent && event.pointerType === 'mouse';

const preventLongPressMenu = (event: MouseEvent) => {
  if (isMouseRightClick(event) || !(event.target instanceof Element)) return;

  if (event.target.closest(LONG_PRESS_MENU_TARGETS)) {
    event.preventDefault();
  }
};

export const BlockTwaLongPressMenu = () => {
  const { isTwa } = useIsMobileApp();

  useEffect(() => {
    if (!isTwa) return undefined;

    document.addEventListener('contextmenu', preventLongPressMenu, true);
    return () => {
      document.removeEventListener('contextmenu', preventLongPressMenu, true);
    };
  }, [isTwa]);

  return null;
};
